import React from "react";
import HousePhoto from "@/images/auth-modal-home.webp";
import "./AuthModalLayout.scss";

const HIGHLIGHTS = [
  "Browse Buyer Want-Listings from local\u00a0agents",
  "Discover and connect with top buyer's agents near\u00a0you",
];

const AuthModalLayout = ({ titleId, title, subtitle, onClose, footer, children }) => (
  <div className="auth-modal">
    <aside className="auth-modal__aside" aria-hidden="true">
      <img className="auth-modal__photo" src={HousePhoto} alt="" loading="lazy" />
      <div className="auth-modal__aside-copy">
        <p className="auth-modal__aside-title">See what buyers want in your&nbsp;area.</p>
        <ul className="auth-modal__highlights">
          {HIGHLIGHTS.map((item) => (
            <li key={item}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </aside>

    <div className="auth-modal__main">
      <button type="button" className="auth-modal__close" aria-label="Close" onClick={onClose}>
        <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
          <path d="M2 2l12 12M14 2L2 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </button>

      <div className="auth-modal__inner">
        <header className="auth-modal__header">
          <h2 id={titleId} className="auth-modal__title">{title}</h2>
          {subtitle && <p className="auth-modal__subtitle">{subtitle}</p>}
        </header>

        <div className="auth-modal__form">{children}</div>

        {footer && <div className="auth-modal__footer">{footer}</div>}
      </div>
    </div>
  </div>
);

export default AuthModalLayout;
